import React from 'react';

import cx from 'classnames';
import { useSelector } from 'react-redux';

import RenderInDomNode from 'components/Pages/Admin/Page/common/RenderInStuff';
import Button from 'components/shared/Button';
import CircleDollar from 'components/shared/Icon/icons/CircleDollar';
import Settings2Icon from 'components/shared/Icon/icons/Settings2';
import { appHasChangesSelector } from 'store/unsavedChanges/selectors';

import s from './index.module.css';
import { useProposalSettings } from './useProposalSettings';

type Props = {
  submitting?: boolean;
};

function ProposalSettingsMenu({ submitting }: Props) {
  const doesAppHaveChanges = useSelector(appHasChangesSelector);
  const disabled = submitting || doesAppHaveChanges;

  const { openActionButtonModal, openSettingsModal } = useProposalSettings();

  return (
    <RenderInDomNode id="proposalSettingsMenu">
      <div className={s.settingMenuContainer}>
        <Button
          type="secondary3"
          size="medium"
          className={s.actionButton}
          onClick={openActionButtonModal}
          disabled={disabled}
        >
          <CircleDollar />
          Book Button
        </Button>

        <Button
          type="default"
          shape="ellipse"
          size="medium"
          className={cx(s.settingsButton, s.actionButton)}
          onClick={openSettingsModal}
          disabled={disabled}
        >
          <Settings2Icon />
          Settings
        </Button>
      </div>
    </RenderInDomNode>
  );
}

export { ProposalSettingsMenu };
